// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__2VEPW","submit":"LoginForm_submit__2moua"};